// Mutation Observer with a function to a certain element
function waitForElm(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }
        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                resolve(document.querySelector(selector));
                observer.disconnect();
            }
        });
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}
// Checking if the PFS search button exists, which means PFS is fully loaded
waitForElm('.boost-pfs-search-btn-close-suggestion').then((elm) => {
    let influenceSearchBar = document.querySelector('search-bar');
    let mobileSearchInfluence = document.querySelector('.mobileSeachBtn');
    let desktopSearchInfluence = document.querySelector('.desktopSeachBtn');
    let mainHeaderSearch = document.querySelector('header');

    
    // Closing native search box when we close PFS search box
    elm.addEventListener("click", function() {
        influenceSearchBar.classList.remove('animate-menu-up-open');
        influenceSearchBar.classList.add('h-0', 'opacity-50', 'invisible');
        mainHeaderSearch.classList.remove('search-opened');
    });
    // Showing native search buttons only when PFS is fully loaded to prevent clicks that do nothing
    mobileSearchInfluence.classList.replace('opacity-30', 'opacity-100');
    mobileSearchInfluence.classList.remove('no-clickable');
    desktopSearchInfluence.classList.replace('opacity-30', 'opacity-100');
    desktopSearchInfluence.classList.remove('no-clickable');
});